"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertiesInAreaAreasPropertiesGetRequest$ = exports.GetPropertiesInAreaAreasPropertiesGetRequest$outboundSchema = exports.GetPropertiesInAreaAreasPropertiesGetRequest$inboundSchema = exports.GetPropertiesInAreaAreasPropertiesGetSecurity$ = exports.GetPropertiesInAreaAreasPropertiesGetSecurity$outboundSchema = exports.GetPropertiesInAreaAreasPropertiesGetSecurity$inboundSchema = void 0;
exports.getPropertiesInAreaAreasPropertiesGetSecurityToJSON = getPropertiesInAreaAreasPropertiesGetSecurityToJSON;
exports.getPropertiesInAreaAreasPropertiesGetSecurityFromJSON = getPropertiesInAreaAreasPropertiesGetSecurityFromJSON;
exports.getPropertiesInAreaAreasPropertiesGetRequestToJSON = getPropertiesInAreaAreasPropertiesGetRequestToJSON;
exports.getPropertiesInAreaAreasPropertiesGetRequestFromJSON = getPropertiesInAreaAreasPropertiesGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetPropertiesInAreaAreasPropertiesGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPropertiesInAreaAreasPropertiesGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertiesInAreaAreasPropertiesGetSecurity$;
(function (GetPropertiesInAreaAreasPropertiesGetSecurity$) {
    /** @deprecated use `GetPropertiesInAreaAreasPropertiesGetSecurity$inboundSchema` instead. */
    GetPropertiesInAreaAreasPropertiesGetSecurity$.inboundSchema = exports.GetPropertiesInAreaAreasPropertiesGetSecurity$inboundSchema;
    /** @deprecated use `GetPropertiesInAreaAreasPropertiesGetSecurity$outboundSchema` instead. */
    GetPropertiesInAreaAreasPropertiesGetSecurity$.outboundSchema = exports.GetPropertiesInAreaAreasPropertiesGetSecurity$outboundSchema;
})(GetPropertiesInAreaAreasPropertiesGetSecurity$ || (exports.GetPropertiesInAreaAreasPropertiesGetSecurity$ = GetPropertiesInAreaAreasPropertiesGetSecurity$ = {}));
function getPropertiesInAreaAreasPropertiesGetSecurityToJSON(getPropertiesInAreaAreasPropertiesGetSecurity) {
    return JSON.stringify(exports.GetPropertiesInAreaAreasPropertiesGetSecurity$outboundSchema.parse(getPropertiesInAreaAreasPropertiesGetSecurity));
}
function getPropertiesInAreaAreasPropertiesGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertiesInAreaAreasPropertiesGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPropertiesInAreaAreasPropertiesGetSecurity' from JSON`);
}
/** @internal */
exports.GetPropertiesInAreaAreasPropertiesGetRequest$inboundSchema = z.object({
    "fields[property]": z.array(shared.MultiplePropertyUserFields$inboundSchema),
    "filter[company_owned]": z.boolean().optional(),
    "filter[council_tax_band]": z.array(shared.CouncilTaxBands$inboundSchema)
        .optional(),
    "filter[energy_efficiency_current_rating]": z.array(shared.EnergyEfficiencyRatings$inboundSchema).optional(),
    "filter[exclude_known_rented]": z.boolean().optional(),
    "filter[garden_direction]": z.array(shared.GardenDirection$inboundSchema)
        .optional(),
    "filter[include_none_residential]": z.boolean().default(false),
    "filter[is_bungalow]": z.boolean().optional(),
    "filter[is_on_the_market]": z.boolean().optional(),
    "filter[max_internal_area_square_metres]": z.number().int().optional(),
    "filter[max_number_of_bedrooms]": z.number().int().optional(),
    "filter[max_outdoor_space_area_square_metres]": z.number().int().optional(),
    "filter[max_price]": z.number().int().optional(),
    "filter[max_price_rounded]": z.number().int().optional(),
    "filter[max_year_built]": z.number().int().optional(),
    "filter[max_years_at_property]": z.number().int().optional(),
    "filter[min_internal_area_square_metres]": z.number().int().optional(),
    "filter[min_number_of_bedrooms]": z.number().int().optional(),
    "filter[min_outdoor_space_area_square_metres]": z.number().int().optional(),
    "filter[min_price]": z.number().int().optional(),
    "filter[min_price_rounded]": z.number().int().optional(),
    "filter[min_year_built]": z.number().int().optional(),
    "filter[min_years_at_property]": z.number().int().optional(),
    "filter[number_of_bedrooms]": z.array(z.number().int()).optional(),
    "filter[overseas_company_owned]": z.boolean().optional(),
    "filter[property_type]": z.array(shared.PropertyType$inboundSchema)
        .optional(),
    "filter[sectors]": z.array(z.string()).optional(),
    "filter[tenure]": z.array(shared.TenureValues$inboundSchema).optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    royal_mail_dependent_locality: z.string().optional(),
    royal_mail_post_town: z.string().optional(),
    royal_mail_thoroughfare: z.string().optional(),
    sector: z.array(z.string()).optional(),
    sort: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "fields[property]": "fieldsProperty",
        "filter[company_owned]": "filterCompanyOwned",
        "filter[council_tax_band]": "filterCouncilTaxBand",
        "filter[energy_efficiency_current_rating]": "filterEnergyEfficiencyCurrentRating",
        "filter[exclude_known_rented]": "filterExcludeKnownRented",
        "filter[garden_direction]": "filterGardenDirection",
        "filter[include_none_residential]": "filterIncludeNoneResidential",
        "filter[is_bungalow]": "filterIsBungalow",
        "filter[is_on_the_market]": "filterIsOnTheMarket",
        "filter[max_internal_area_square_metres]": "filterMaxInternalAreaSquareMetres",
        "filter[max_number_of_bedrooms]": "filterMaxNumberOfBedrooms",
        "filter[max_outdoor_space_area_square_metres]": "filterMaxOutdoorSpaceAreaSquareMetres",
        "filter[max_price]": "filterMaxPrice",
        "filter[max_price_rounded]": "filterMaxPriceRounded",
        "filter[max_year_built]": "filterMaxYearBuilt",
        "filter[max_years_at_property]": "filterMaxYearsAtProperty",
        "filter[min_internal_area_square_metres]": "filterMinInternalAreaSquareMetres",
        "filter[min_number_of_bedrooms]": "filterMinNumberOfBedrooms",
        "filter[min_outdoor_space_area_square_metres]": "filterMinOutdoorSpaceAreaSquareMetres",
        "filter[min_price]": "filterMinPrice",
        "filter[min_price_rounded]": "filterMinPriceRounded",
        "filter[min_year_built]": "filterMinYearBuilt",
        "filter[min_years_at_property]": "filterMinYearsAtProperty",
        "filter[number_of_bedrooms]": "filterNumberOfBedrooms",
        "filter[overseas_company_owned]": "filterOverseasCompanyOwned",
        "filter[property_type]": "filterPropertyType",
        "filter[sectors]": "filterSectors",
        "filter[tenure]": "filterTenure",
        "royal_mail_dependent_locality": "royalMailDependentLocality",
        "royal_mail_post_town": "royalMailPostTown",
        "royal_mail_thoroughfare": "royalMailThoroughfare",
    });
});
/** @internal */
exports.GetPropertiesInAreaAreasPropertiesGetRequest$outboundSchema = z.object({
    fieldsProperty: z.array(shared.MultiplePropertyUserFields$outboundSchema),
    filterCompanyOwned: z.boolean().optional(),
    filterCouncilTaxBand: z.array(shared.CouncilTaxBands$outboundSchema)
        .optional(),
    filterEnergyEfficiencyCurrentRating: z.array(shared.EnergyEfficiencyRatings$outboundSchema).optional(),
    filterExcludeKnownRented: z.boolean().optional(),
    filterGardenDirection: z.array(shared.GardenDirection$outboundSchema)
        .optional(),
    filterIncludeNoneResidential: z.boolean().default(false),
    filterIsBungalow: z.boolean().optional(),
    filterIsOnTheMarket: z.boolean().optional(),
    filterMaxInternalAreaSquareMetres: z.number().int().optional(),
    filterMaxNumberOfBedrooms: z.number().int().optional(),
    filterMaxOutdoorSpaceAreaSquareMetres: z.number().int().optional(),
    filterMaxPrice: z.number().int().optional(),
    filterMaxPriceRounded: z.number().int().optional(),
    filterMaxYearBuilt: z.number().int().optional(),
    filterMaxYearsAtProperty: z.number().int().optional(),
    filterMinInternalAreaSquareMetres: z.number().int().optional(),
    filterMinNumberOfBedrooms: z.number().int().optional(),
    filterMinOutdoorSpaceAreaSquareMetres: z.number().int().optional(),
    filterMinPrice: z.number().int().optional(),
    filterMinPriceRounded: z.number().int().optional(),
    filterMinYearBuilt: z.number().int().optional(),
    filterMinYearsAtProperty: z.number().int().optional(),
    filterNumberOfBedrooms: z.array(z.number().int()).optional(),
    filterOverseasCompanyOwned: z.boolean().optional(),
    filterPropertyType: z.array(shared.PropertyType$outboundSchema).optional(),
    filterSectors: z.array(z.string()).optional(),
    filterTenure: z.array(shared.TenureValues$outboundSchema).optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    royalMailDependentLocality: z.string().optional(),
    royalMailPostTown: z.string().optional(),
    royalMailThoroughfare: z.string().optional(),
    sector: z.array(z.string()).optional(),
    sort: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        fieldsProperty: "fields[property]",
        filterCompanyOwned: "filter[company_owned]",
        filterCouncilTaxBand: "filter[council_tax_band]",
        filterEnergyEfficiencyCurrentRating: "filter[energy_efficiency_current_rating]",
        filterExcludeKnownRented: "filter[exclude_known_rented]",
        filterGardenDirection: "filter[garden_direction]",
        filterIncludeNoneResidential: "filter[include_none_residential]",
        filterIsBungalow: "filter[is_bungalow]",
        filterIsOnTheMarket: "filter[is_on_the_market]",
        filterMaxInternalAreaSquareMetres: "filter[max_internal_area_square_metres]",
        filterMaxNumberOfBedrooms: "filter[max_number_of_bedrooms]",
        filterMaxOutdoorSpaceAreaSquareMetres: "filter[max_outdoor_space_area_square_metres]",
        filterMaxPrice: "filter[max_price]",
        filterMaxPriceRounded: "filter[max_price_rounded]",
        filterMaxYearBuilt: "filter[max_year_built]",
        filterMaxYearsAtProperty: "filter[max_years_at_property]",
        filterMinInternalAreaSquareMetres: "filter[min_internal_area_square_metres]",
        filterMinNumberOfBedrooms: "filter[min_number_of_bedrooms]",
        filterMinOutdoorSpaceAreaSquareMetres: "filter[min_outdoor_space_area_square_metres]",
        filterMinPrice: "filter[min_price]",
        filterMinPriceRounded: "filter[min_price_rounded]",
        filterMinYearBuilt: "filter[min_year_built]",
        filterMinYearsAtProperty: "filter[min_years_at_property]",
        filterNumberOfBedrooms: "filter[number_of_bedrooms]",
        filterOverseasCompanyOwned: "filter[overseas_company_owned]",
        filterPropertyType: "filter[property_type]",
        filterSectors: "filter[sectors]",
        filterTenure: "filter[tenure]",
        royalMailDependentLocality: "royal_mail_dependent_locality",
        royalMailPostTown: "royal_mail_post_town",
        royalMailThoroughfare: "royal_mail_thoroughfare",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertiesInAreaAreasPropertiesGetRequest$;
(function (GetPropertiesInAreaAreasPropertiesGetRequest$) {
    /** @deprecated use `GetPropertiesInAreaAreasPropertiesGetRequest$inboundSchema` instead. */
    GetPropertiesInAreaAreasPropertiesGetRequest$.inboundSchema = exports.GetPropertiesInAreaAreasPropertiesGetRequest$inboundSchema;
    /** @deprecated use `GetPropertiesInAreaAreasPropertiesGetRequest$outboundSchema` instead. */
    GetPropertiesInAreaAreasPropertiesGetRequest$.outboundSchema = exports.GetPropertiesInAreaAreasPropertiesGetRequest$outboundSchema;
})(GetPropertiesInAreaAreasPropertiesGetRequest$ || (exports.GetPropertiesInAreaAreasPropertiesGetRequest$ = GetPropertiesInAreaAreasPropertiesGetRequest$ = {}));
function getPropertiesInAreaAreasPropertiesGetRequestToJSON(getPropertiesInAreaAreasPropertiesGetRequest) {
    return JSON.stringify(exports.GetPropertiesInAreaAreasPropertiesGetRequest$outboundSchema.parse(getPropertiesInAreaAreasPropertiesGetRequest));
}
function getPropertiesInAreaAreasPropertiesGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertiesInAreaAreasPropertiesGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPropertiesInAreaAreasPropertiesGetRequest' from JSON`);
}
//# sourceMappingURL=getpropertiesinareaareaspropertiesget.js.map